<template>
  <div class="active_table" ref="content">
    <toolbar>
      <div class="search" style="width: 100%">
        <!-- 企业选择 -->
        <div class="label">企业名称：</div>
        <Select
          v-model="search.uuid"
          style="width: 7.8em;margin-right:1em;"
          @on-change="getSiteList"
          placeholder="请选择企业"
          clearable
        >
          <Option v-for="item in companyList" :value="item.uuid" :key="item.id">{{ item.name }}</Option>
        </Select>
        <!-- 站点选择 -->
        <div class="label">选择站点：</div>
        <Select
          v-model="search.siteId"
          style="width: 7.8em"
          @on-change="selectDevice($event)"
          placeholder="请选择站点"
          clearable
        >
          <Option v-for="item in siteList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <div class="label" style="margin-left: 10px">选择设备：</div>
        <Select v-model="search.siteDeviceId" style="width: 7.8em;" placeholder="请选择设备" clearable>
          <Option v-for="item in deviceList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <!-- <DatePicker
          type="daterange"
          placement="bottom-end"
          placeholder="选择日期"
          style="width: 200px;margin-left: 10px"
          @on-change="dateSelect($event)"
        ></DatePicker>-->
        <!-- <Select
          v-model="search.timeSegmentation"
          clearable
          style="width:100px;margin-left:10px;text-align:center;"
        >
          <Option
            v-for="item in timeSegmentationList"
            :key="item.value"
            :value="item.value"
          >{{ item.name }}</Option>
        </Select>-->
        <i-button type="default" @click="searchFunc" style="margin-left: 1em;">搜索</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :max-height="table.maxHeight" :data="table.data"></i-table>
      <Page
        :total="table.total"
        show-sizer
        :page-size="40"
        @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)"
        style="text-align:right;margin-top: 1em"
      />
      <Spin fix v-show="table.loading"></Spin>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
  padding-top: 2em;
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 5.5em);
  position: relative;
}
.content {
  width: 700px;
  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../../../p_company/components/toolBar.vue"; // 操作栏组件
import { timeStamp } from "../../../util/common/date"; // 时间转化工具
import { emComputed } from "../../../util/common/fontSize"; // em转化工具
import { Resize } from "../../../util/common/resize";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            title: "企业名称",
            key: "companyName",
            align: "center"
          },
          {
            title: "车间名称",
            key: "siteName",
            align: "center"
          },
          {
            title: "设备名称",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("span", {}, params.row.contentTypeValueList[0])
              ]);
            }
          },
          {
            title: "状态",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("span", {}, params.row.contentTypeValueList[1])
              ]);
            }
          },
          {
            title: "内容",
            key: "contentTypeName",
            align: "center"
          },
          {
            title: "日期",
            key: "createDate",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.createDate, "yyyy-MM-dd HH:mm")
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 40,
        total: 0,
        loading: true,
        maxHeight: null
      },
      // 查询
      search: {
        siteId: null,
        siteDeviceId: null,
        // startDate: new Date().setHours("0"),
        // endDate: new Date().getTime(),
        // timeSegmentation: null,
        uuid: null,
        showAll: true
      },
      siteList: [], // 站点枚举列表
      deviceList: [], // 设备枚举
      timeSegmentationList: [
        {
          name: "每分钟",
          value: 60
        },
        {
          name: "每十分钟",
          value: 600
        },
        {
          name: "每小时",
          value: 3600
        }
      ],
      // 企业列表
      companyList: []
    };
  },
  components: {
    toolbar
  },
  created: async function() {
    await this.getCompany(); // 获取企业列表
    this.getSiteList(); // 获取站点枚举
    this.getData();
    this.tableInit(); // 表格初始化
    window.addEventListener("resize", this.tableInit);
  },
  methods: {
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Warn.getWarnDataList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        [null, "park"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          //console.log(res);
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    // 获取站点枚举值
    getSiteList() {
      this.$api.Enum.getSiteEnum({ content: { uuid: this.search.uuid } }, [
        null,
        "park"
      ]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取设备
    selectDevice(msg) {
      let siteList = this.siteList;
      let site = siteList.filter(res => {
        return res.id == msg;
      });
      this.$api.Enum.getDeviceEnum({ content: { mn: site[0].mn } }, [
        "uuids",
        "park"
      ]).then(res => {
        if (res.code == 0) {
          this.deviceList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取端口对应设备失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      this.search.endDate = new Date(date[1]).setHours("24");
    },
    // 表格高度计算
    tableInit() {
      this.$nextTick(() => {
        if (this.$route.path != "/ahome/warnEvent") {
          window.removeEventListener("resize", this.tableInit);
          return false;
        }
        let tableH = this.$refs.content.clientHeight;
        let headerH = emComputed(9.5); // 操作栏5.5em转换px， 2em的上下边距分页组件
        this.table.maxHeight = tableH - headerH - 32; // 32px的分页组件高度
      });
    },
    // 获取企业列表
    getCompany() {
      return new Promise((resolve, reject) => {
        this.$api.A_Company.getCompanyHomeList(null, ["uuids", "park"]).then(
          res => {
            if (res.code == 0) {
              let data = res.data;
              this.companyList = data;
              this.search.uuid = data[0].uuid;
              resolve();
            } else {
              this.$Notice.warning({
                title: "获取企业列表失败",
                desc: res.message || "请联系管理员"
              });
            }
          }
        );
      });
    }
  }
};
</script>